import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ContactComponent} from '@common/contact/contact.component';
import {MaterialNavbarModule} from '@common/core/ui/material-navbar/material-navbar.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslationsModule} from '@common/core/translations/translations.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ContactService } from 'src/app/contact-us/contact.service';
import { AppFooterModule } from '@common/shared/app-footer/app-footer.module';


@NgModule({
    declarations: [
        ContactComponent,
    ],
    imports: [
        CommonModule,
        MaterialNavbarModule,
        FormsModule,
        ReactiveFormsModule,
        TranslationsModule,
        MatButtonModule,
        MatFormFieldModule,
        AppFooterModule 
    ],
    exports: [
        ContactComponent,
    ],
    providers:[ContactService]
})
export class ContactPageModule {
}
